'use client';

import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';

import { getImageAlt, getImageUrl } from '../../../services/utils/image';

export interface ProductHeroSectionProps {
  title: string;
  subtitle?: string;
  backgroundImage?: any;
}

const ProductHeroSection = ({
  title,
  subtitle,
  backgroundImage,
}: ProductHeroSectionProps) => {
  const imageUrl = getImageUrl(backgroundImage);
  const imageAlt = getImageAlt(backgroundImage);

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: 300, md: 400 },
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: '#1A1A1A',
      }}
    >
      {/* Background Image */}
      {backgroundImage && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
          }}
        >
          <Image
            src={imageUrl}
            alt={imageAlt}
            fill
            style={{ objectFit: 'cover' }}
            sizes='100vw'
            priority
          />
          {/* Overlay */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(26, 26, 26, 0.7)',
            }}
          />
        </Box>
      )}

      {/* Content */}
      <Container
        maxWidth='lg'
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          color: 'white',
        }}
      >
        <Typography
          variant='h2'
          component='h1'
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
            lineHeight: 1.2,
            marginBottom: subtitle ? 2 : 0,
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography
            variant='h5'
            sx={{
              fontWeight: 400,
              fontSize: { xs: '1.125rem', md: '1.25rem' },
              lineHeight: 1.5,
              maxWidth: 600,
              margin: '0 auto',
              opacity: 0.9,
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default ProductHeroSection;
